import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DonorCrmService } from 'src/app/shared/services/donor-crm/donor-crm.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { CommonSharedServiceService } from 'src/app/shared/shared-services/common-shared-service/common-shared-service.service';

@Component({
  selector: 'app-donation-requests',
  templateUrl: './donation-requests.component.html',
  styleUrl: './donation-requests.component.scss',
})
export class DonationRequestsComponent {
  @Input() ngoId: string | null = null;
  @Input() campaignId: string | null = null;
  @Input() created_at: string | null = null;

  public donationSummaryPopup: boolean = false;

  public allFundraisers = [
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'bKash',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Pending',
    },
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'Rocket',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Pending',
    },
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'Nagad',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Approved',
    },
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'bKash',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Rejected',
    },
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'Rocket',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Pending',
    },
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'Nagad',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Pending',
    },
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'bKash',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Approved',
    },
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'Rocket',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Rejected',
    },
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'Nagad',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Pending',
    },
    {
      donor_id: '40f82a91-26b1-4a1f-8554-5c03f00504f7',
      donorName: 'Maksudur Rahman',
      phoneNumber: '01786062801',
      transactionId: '71NXMA9X',
      paymentMethod: 'Nagad',
      updated_at: '2025-01-02T18:56:22.193Z',
      amount: 10000,
      campaign: 'Student Welfare Relief Fund - 2024',
      status: 'Approved',
    },
  ];

  public today: Date = new Date();
  public oneYearAgo: Date = new Date(
    this.today.getFullYear() - 1,
    this.today.getMonth(),
    this.today.getDate(),
    this.today.getHours(),
    this.today.getMinutes(),
    this.today.getSeconds(),
    this.today.getMilliseconds()
  );

  public startDate: Date = this.created_at
    ? new Date(this.created_at)
    : new Date(this.oneYearAgo);
  public endDate: Date = this.today;
  public selectedStatus: string = 'ALL';
  public recentActivity = [];
  public donatedDonations = [];
  public pledgingDonations = [];
  public sessionUser: any;
  public selectedRole = this.localStorageService.getSelectedRole();
  constructor(
    private readonly router: Router,
    private readonly donorCrmService: DonorCrmService,
    private readonly localStorageService: LocalStorageService,
    private readonly sharedService: CommonSharedServiceService
  ) {
    this.sessionUser = this.localStorageService.getSessionUser();
  }

  ngOnInit() {
    if (this.ngoId) {
      this.getAllDonorCrmActivity();
    }
  }

  public updateDateRange(event: any) {
    if (event && event.value) {
      this.startDate = event.value[0]; // First value is startDate
      this.endDate = event.value[1]; // Second value is endDate
      this.getAllDonorCrmActivity();
    }
  }

  public showDetailPopup(receipt: any): void {
    //this.sharedService.updateReceiptPopupState(true);
  }

  public getAllDonorCrmActivity(): void {
    this.donorCrmService
      .getDonorCrmDashboardActivity(
        this.startDate.toISOString(),
        this.endDate.toISOString(),
        this.selectedStatus,
        this.ngoId,
        [this.campaignId]
      )
      .subscribe({
        next: (result: any) => {
          this.donatedDonations = result.donated_donations;
          this.pledgingDonations = result.pledging_donations;
          this.filterRecentActivity();
        },
      });
  }

  public filterRecentActivity(): void {
    if (this.selectedStatus === 'ALL') {
      this.recentActivity = [
        ...this.donatedDonations,
        ...this.pledgingDonations.map((donation) => ({
          ...donation,
          amount: donation.pledged_amount,
          status: donation.pledging_status,
        })),
      ];
    }
    this.recentActivity.sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );
  }
}
